import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../utils/domain/routingComponents'
import {
  itemPriceManagementAccessControl,
  itemPriceManagementModifyAccessControl,
  itemPriceManagementApproveAccessControl,
} from '../access-control/itemPriceManagementAccess.configuration'

const ItemPriceManagementTabbedPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ItemPriceManagementTabbedPage" */
      '../pages/ItemPriceManagementTabbedPage'
    )
)
const ItemPriceManagementRulesPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ItemPriceManagementRulesPage" */
      '../pages/rules/ItemPriceManagementRulesPage'
    )
)
const CompareRulesView = lazy(
  () =>
    import(
      /* webpackChunkName: "CompareRulesView" */
      '../pages/rules/CompareRulesView'
    )
)
const ItemPriceManagementChangeRequestPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ItemPriceManagementChangeRequestPage" */
      '../pages/change-request/ItemPriceManagementChangeRequestPage'
    )
)
const ItemPriceManagementChangeRequestReviewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ItemPriceManagementChangeRequestReviewPage" */
      '../pages/change-request-review/ItemPriceManagementChangeRequestReviewPage'
    )
)
const ItemPriceManagementProductListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ItemPriceManagementProductListPage" */
      '../pages/product-list/ItemPriceManagementProductListPage'
    )
)
// @hygen:inject page-import

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ProductListViewPage: React.ComponentType<any> = props => (
  <ItemPriceManagementProductListPage {...props} mode="view" />
)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ProductListEditPage: React.ComponentType<any> = props => (
  <ItemPriceManagementProductListPage {...props} mode="edit" />
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ChangeRequestCreatePage: React.ComponentType<any> = props => (
  <ItemPriceManagementChangeRequestPage {...props} mode="create" />
)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ChangeRequestViewPage: React.ComponentType<any> = props => (
  <ItemPriceManagementChangeRequestPage {...props} mode="view" />
)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ChangeRequestEditPage: React.ComponentType<any> = props => (
  <ItemPriceManagementChangeRequestPage {...props} mode="edit" />
)

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const itemPriceManagementRouter = (
  <DomainRoute route="item-price-management" accessControl={itemPriceManagementAccessControl}>
    <DashSwitch>
      {/* Product list routes (most specific first) */}
      <DomainRoute
        exact
        route="item-price-management-product-list-edit"
        component={ProductListEditPage}
      />
      <DomainRoute
        exact
        route="item-price-management-product-list-detail"
        component={ProductListViewPage}
      />
      {/* Detail routes (more specific paths first) */}
      <DomainRoute exact route="item-price-management-rules-compare" component={CompareRulesView} />
      <DomainRoute
        exact
        route="item-price-management-rules"
        component={ItemPriceManagementRulesPage}
      />
      <DomainRoute
        exact
        route="item-price-management-active-rules"
        component={ItemPriceManagementTabbedPage}
      />
      <DomainRoute
        exact
        route="item-price-management-change-request-create"
        accessControl={itemPriceManagementModifyAccessControl}
        component={ChangeRequestCreatePage}
      />
      <DomainRoute
        exact
        route="item-price-management-change-request-edit"
        accessControl={itemPriceManagementModifyAccessControl}
        component={ChangeRequestEditPage}
      />
      <DomainRoute
        exact
        route="item-price-management-change-request-review"
        accessControl={itemPriceManagementApproveAccessControl}
        component={ItemPriceManagementChangeRequestReviewPage as any}
      />
      <DomainRoute
        exact
        route="item-price-management-change-request-detail"
        component={ChangeRequestViewPage}
      />
      {/* Tabbed page routes */}
      <DomainRoute
        exact
        route="item-price-management-change-requests"
        component={ItemPriceManagementTabbedPage}
      />
      <DomainRoute
        exact
        route="item-price-management-groups"
        component={ItemPriceManagementTabbedPage}
      />
      {/* Default redirect for base path */}
      <DomainRedirect
        fromRoute="item-price-management"
        toRoute="item-price-management-change-requests"
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
